import { memo, type PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import Label from "./Label";
import Divider from "./Divider";

const Timeline = ({ children }: PropsWithChildren) => (
    <Box>
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                alignItems: 'center',
                justifyContent: 'space-between'
            }}
        >
            <Label>
                Previous
            </Label>
            <Divider />
            <Label>
                Reason
            </Label>
            <Divider />
            <Label>
                Current
            </Label>
        </Box>
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'minmax(min-content, 400px) 1fr minmax(min-content, 400px)',
                alignItems: 'flex-end',
                mt: 3
            }}
        >
            {children}
        </Box>
    </Box>
);

export default memo(Timeline);
